import {Button, Dropdown, Menu, Modal} from 'antd';
import Call from '../../../../hocs/call';
import React from 'react';
import EnhancedTree from '../../../../components/enhanced-tree';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {compose} from 'redux';
import {createBuilderCategoryForm} from '../category-form/actions';
import {getLocalizedStr} from '../../../../middlewares/i18n/utils';
import {getNode, UNCATEGORIZED_CATEGORY_CODE} from '../../../../utils/tree';
import {DCS_ORDERED_TREE_ROOT as DCS, DCS_ORDERED_TREE_ROOT} from '../../../../utils/treeBuilders';
import {COLOR_FONT_DISABLED, SPAN_HALF} from "../../../../styles/constants";
import {
  createBuilderCubeTreeCube,
  deleteBuilderCubeTreeCategory,
  deleteBuilderCubeTreeCube,
  moveBuilderCubeTreeCategory,
  readBuilderCubeTreeCategorisedCubes,
  selectBuilderCubeTreeCube,
  selectBuilderCubeTreeCubeCategory
} from "./actions";

const CREATE_BUTTON_ITEM_CREATE_CUBE = "CREATE_BUTTON_ITEM_CREATE_CUBE";
const CREATE_BUTTON_ITEM_CREATE_CATEGORY = "CREATE_BUTTON_ITEM_CREATE_CATEGORY";

const mapStateToProps = (state) => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  categorisedCubes: state.scenes.dataManager.builder.shared.categorisedCubes,
  selectedCubeId: state.scenes.dataManager.builder.shared.cubeId,
  category: state.scenes.dataManager.builder.shared.category,
  permissions: state.app.user.permissions,
  forbiddenCubesCodes: state.scenes.dataManager.builder.shared.forbiddenCubesCodes,
  forbiddenCategoriesCodes: state.scenes.dataManager.builder.shared.forbiddenCategoriesCodes
});

const mapDispatchToProps = dispatch => ({
  onCubeSelect: cubeId => dispatch(selectBuilderCubeTreeCube(cubeId)),
  onCategorySelect: category => dispatch(selectBuilderCubeTreeCubeCategory(category)),
  onCubeCreate: categoryId => dispatch(createBuilderCubeTreeCube(categoryId)),
  onCubeDelete: cubeId => dispatch(deleteBuilderCubeTreeCube(cubeId)),
  onCategoryCreate: parCode => dispatch(createBuilderCategoryForm(parCode)),
  onCategoryDelete: catCode => dispatch(deleteBuilderCubeTreeCategory(catCode)),
  fetchCategorisedCubes: ({forbiddenCubesCodes, forbiddenCategoriesCodes}) =>
    dispatch(readBuilderCubeTreeCategorisedCubes(forbiddenCubesCodes, forbiddenCategoriesCodes)),
  onCategoryMove: categories => dispatch(moveBuilderCubeTreeCategory(categories))
});

const disabledItemStyle = {
  cursor: "not-allowed",
  color: COLOR_FONT_DISABLED
};

const onDrop = (ev, categorisedCubes, t, onCategoryMove) => {

  const pos = ev.node.props.pos.split('-');
  const dropPos = ev.dropPosition - Number(pos[pos.length - 1]);

  const draggedNode = ev.dragNode.props["data-node"];
  const targetNode = ev.node.props["data-node"];

  if (draggedNode.CatCode && targetNode.CatCode && draggedNode.CatCode !== targetNode.CatCode &&
    draggedNode.CatCode !== DCS_ORDERED_TREE_ROOT.CatCode) {

    if (ev.dropToGap && targetNode.CatCode !== DCS.CatCode) {
      // moved next to a category (but not next to the root)

      draggedNode.Ord = dropPos > 0
        ? String(Number(targetNode.Ord) + Number("0.1"))
        : String(Number(targetNode.Ord) - Number("0.1"));

      const targetParentNode = getNode(categorisedCubes, "children", node =>
        node.CatCode === targetNode.ParCode ||
        (targetNode.ParCode === null && node.CatCode === DCS_ORDERED_TREE_ROOT.CatCode)
      );

      if (
        (targetParentNode.CatCode !== DCS.CatCode && draggedNode.ParCode !== targetParentNode.CatCode) ||
        (targetParentNode.CatCode === DCS.CatCode && draggedNode.ParCode !== null)
      ) {
        // parent has to be changed

        targetParentNode.children.push(draggedNode);
        draggedNode.ParCode = targetParentNode.CatCode !== DCS.CatCode
          ? targetParentNode.CatCode
          : null;
      }

      targetParentNode.children = targetParentNode.children.sort((a, b) => {
        if (a.Ord !== undefined && b.Ord !== undefined) {
          return a.Ord - b.Ord;
        } else if (a.Ord !== undefined) {
          return a;
        } else if (b.Ord !== undefined) {
          return b;
        } else {
          return (a.CatCode || -1) - (b.CatCode || -1);
        }
      });

      let ordCount = 1;
      targetParentNode.children = targetParentNode.children.map(c => ({
        ...c,
        Ord: c.Ord !== undefined ? String(ordCount++) : undefined
      }));

      onCategoryMove(targetParentNode.children.filter(c => c.CatCode !== undefined));

    } else if (
      (targetNode.CatCode !== DCS.CatCode && draggedNode.ParCode !== targetNode.CatCode) ||
      (targetNode.CatCode === DCS.CatCode && draggedNode.ParCode !== null)
    ) {
      // moved into a category (not the parent)

      draggedNode.Ord = String(targetNode.children.filter(c => c.CatCode !== undefined).length + 1);
      draggedNode.ParCode = targetNode.CatCode !== DCS.CatCode ? targetNode.CatCode : null;

      onCategoryMove([draggedNode]);
    }
  } else {

    Modal.error({
      title: t('scenes.dataManager.builder.cubeTree.modals.forbiddenDragNDrop.title'),
      content: t('scenes.dataManager.builder.cubeTree.modals.forbiddenDragNDrop.content')
    })
  }

};

const BuilderCategorisedCubesTree = ({
                                       t,
                                       appLanguage,
                                       permissions,
                                       dataLanguages,
                                       categorisedCubes,
                                       selectedCubeId,
                                       category,
                                       forbiddenCubesCodes,
                                       forbiddenCategoriesCodes,
                                       onCubeSelect,
                                       onCategorySelect,
                                       onCubeCreate,
                                       onCubeDelete,
                                       onCategoryCreate,
                                       onCategoryDelete,
                                       onCategoryMove,
                                       fetchCategorisedCubes
                                     }) => {

  const isAdmin = permissions && permissions.rules && permissions.rules.includes("AdminRole");

  const isCreateCubeDisabled = category =>
    category === null || category.CatCode === null ||
    forbiddenCategoriesCodes.includes(category.CatCode);

  const addAction = isAdmin
    ? {
      title: t('scenes.dataManager.builder.cubeTree.createButton.title'),
      icon: 'plus',
      render: props =>
        <Dropdown
          disabled={category === null || category.IDCat === null}
          trigger={['click']}
          overlay={
            <Menu
              onClick={({key}) => {
                switch (key) {
                  case CREATE_BUTTON_ITEM_CREATE_CUBE:
                    if (!isCreateCubeDisabled(category)) {
                      onCubeCreate(category.IDCat);
                    }
                    break;
                  case CREATE_BUTTON_ITEM_CREATE_CATEGORY:
                    onCategoryCreate(category.CatCode);
                    break;
                  default:
                    break;
                }
              }}
            >
              <Menu.Item key={CREATE_BUTTON_ITEM_CREATE_CUBE}>
                <a
                  style={
                    isCreateCubeDisabled(category)
                      ? disabledItemStyle
                      : null
                  }
                >
                  {t('scenes.dataManager.builder.cubeTree.createButton.items.createCube')}
                </a>
              </Menu.Item>
              <Menu.Item key={CREATE_BUTTON_ITEM_CREATE_CATEGORY}>
                <a style={category === null ? disabledItemStyle : null}>
                  {t('scenes.dataManager.builder.cubeTree.createButton.items.createCategory')}
                </a>
              </Menu.Item>
            </Menu>
          }
        >
          <Button {...props}/>
        </Dropdown>
    }
    : {
      disabled: category === null || forbiddenCategoriesCodes.includes(category.CatCode),
      title: t('scenes.dataManager.builder.cubeTree.createButton.title'),
      icon: 'plus',
      onClick: () => onCubeCreate(category.IDCat)
    };

  const deleteAction = isAdmin
    ? {
      disabled:
        selectedCubeId === null && (
          category === null || category.IDCat === null ||
          category.CatCode === DCS_ORDERED_TREE_ROOT.CatCode ||
          category.children.length > 0
        ),
      title: selectedCubeId !== null
        ? t('scenes.dataManager.builder.cubeTree.deleteButton.cube.title')
        : (category !== null && category.IDCat !== null)
          ? t('scenes.dataManager.builder.cubeTree.deleteButton.category.title')
          : null,
      icon: 'delete',
      onClick: () => Modal.confirm({
        title: selectedCubeId !== null
          ? t('scenes.dataManager.builder.cubeTree.deleteButton.cube.confirm', {
            id: getNode(
              categorisedCubes,
              'children',
              node => node.IDCube === selectedCubeId
            ).Code
          })
          : t('scenes.dataManager.builder.cubeTree.deleteButton.category.confirm', {id: category.CatCode}),
        onOk() {
          if (selectedCubeId !== null) {
            onCubeDelete(selectedCubeId);
          } else {
            onCategoryDelete(category.CatCode);
          }
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    }
    : {
      disabled: selectedCubeId === null,
      title: t('scenes.dataManager.builder.cubeTree.deleteButton.cube.title'),
      icon: 'delete',
      onClick: () => Modal.confirm({
        title: t('scenes.dataManager.builder.cubeTree.deleteButton.cube.confirm', {
          id: getNode(
            categorisedCubes,
            'children',
            node => node.IDCube === selectedCubeId
          ).Code
        }),
        onOk() {
          onCubeDelete(selectedCubeId);
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    };

  return (
    <Call
      cb={fetchCategorisedCubes}
      cbParam={{forbiddenCubesCodes, forbiddenCategoriesCodes}}
      disabled={categorisedCubes !== null}
    >
      <EnhancedTree
        tree={categorisedCubes}
        childrenKey="children"
        getNodeKey={node => node.children
          ? (node.CatCode || node.labels)
          : "CUBE@" + (node.Code || node.labels)
        }
        idKey="Code"
        nameKey="labels"
        catIdKey="CatCode"
        catNameKey="labels"
        unselectableKeys={[UNCATEGORIZED_CATEGORY_CODE]}
        hiddenIdKeys={[DCS_ORDERED_TREE_ROOT.CatCode, UNCATEGORIZED_CATEGORY_CODE]}
        unallowedIdKeys={
          !!forbiddenCategoriesCodes && !!forbiddenCubesCodes
            ? forbiddenCubesCodes.concat(forbiddenCategoriesCodes)
            : []
        }
        getFilter={
          searchText =>
            ({Code, CatCode, labels}) => {
              const search = searchText.toLowerCase();
              return (Code && Code.toLowerCase()
                  .indexOf(search) >= 0) ||
                (CatCode && CatCode.toLowerCase()
                  .indexOf(search) >= 0) ||
                getLocalizedStr(labels, appLanguage, dataLanguages)
                  .toLowerCase()
                  .indexOf(search) >= 0;
            }
        }
        actions={[
          addAction,
          deleteAction
        ]}
        onSelect={
          selectedArr => {
            if (selectedArr !== null && selectedArr.length > 0) {
              const node = getNode(
                categorisedCubes,
                'children',
                node => node.children
                  ? node.CatCode === selectedArr[0]
                  : node.Code === selectedArr[0].split("@")[1]
              );
              if (node && node.children) {
                onCategorySelect({
                  ...node,
                  CatCode: node.CatCode !== DCS_ORDERED_TREE_ROOT.CatCode ? node.CatCode : null
                });
                if (!isAdmin &&
                  node.CatCode !== DCS_ORDERED_TREE_ROOT.CatCode &&
                  forbiddenCategoriesCodes.includes(node.CatCode)
                ) {
                  Modal.error({
                    title: t('scenes.dataManager.builder.cubeTree.modals.forbiddenCategory.title'),
                    content: t('scenes.dataManager.builder.cubeTree.modals.forbiddenCategory.content')
                  })
                }
              } else {
                onCategorySelect(null);
              }
              onCubeSelect((node && !node.children && !forbiddenCubesCodes.includes(node.Code)) ? node.IDCube : null);
              if (node && forbiddenCubesCodes.includes(node.Code)) {
                Modal.error({
                  title: t('scenes.dataManager.builder.cubeTree.modals.forbiddenNode.title'),
                  content: t('scenes.dataManager.builder.cubeTree.modals.forbiddenNode.content')
                });
              }
            } else {
              onCategorySelect(null);
              onCubeSelect(null);
            }
          }
        }
        treeActions={[
          {
            title: t('scenes.dataManager.builder.cubeTree.refreshButton.title'),
            icon: 'sync',
            onClick: () => fetchCategorisedCubes(forbiddenCubesCodes, forbiddenCategoriesCodes),
          }
        ]}
        icon="cube"
        isCustomIcon
        getIconColor={() => "#37a0f4"}
        searchBarSpan={SPAN_HALF}
        draggable={isAdmin}
        onDrop={e => onDrop(e, categorisedCubes, t, onCategoryMove)}
      />
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(BuilderCategorisedCubesTree);